import homeSelectors from 'src/modules/home/homeSelectors'
import { VideoObject } from 'src/modules/shared/Types'
import ItemVideo1 from 'src/view/home/ItemVideo1'
import ItemVideo2 from 'src/view/home/ItemVideo2'
import Spinner from 'src/view/shared/Spinner'
import homeConstants from 'src/modules/home/homeConstants'
import { Box, Grid, Tabs } from '@mui/material'
import { useAppSelector } from 'src/modules/hooks'

const styles = (theme) => ({
  iconSize: {
    '& .MuiSvgIcon-root': {
      fontSize: '50px',
    },
  },
  iconPadding: {
    '& .MuiTabScrollButton-root': {
      paddingBottom: '50px',
    },
  },
  showWhenDisabled: {
    '& .Mui-disabled': {
      opacity: 0.1,
    },
  },
  hideWhenDisabled: {
    '& .Mui-disabled': {
      opacity: 0,
      height: 0,
    },
  },
  category: {
    backgroundColor: theme.palette.type === 'dark' ? 'white' : 'black',
    color: theme.palette.type === 'dark' ? 'black' : 'white',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    textTransform: 'uppercase',
  },
})

const OnDemandVideoList = ({ activeVideo }) => {
  return (
    <Grid container spacing={4}>
      <Grid size={{ xs: 12, md: 8 }}>
        <CategorySection category={homeConstants.categories[1]} activeVideo={activeVideo} />
        <CategorySection category={homeConstants.categories[2]} activeVideo={activeVideo} />
        <CategorySection category={homeConstants.categories[3]} activeVideo={activeVideo} />
        <CategorySection category={homeConstants.categories[4]} activeVideo={activeVideo} />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <CategorySectionLatest category={homeConstants.categories[0]} activeVideo={activeVideo} />
      </Grid>
    </Grid>
  )
}

const CategorySection = ({ category, activeVideo }) => {
  const fetchLoading = useAppSelector(homeSelectors.selectFetchVideosLoading(category.id))
  const onDemandVideos: Array<VideoObject> = useAppSelector(homeSelectors.selectOnDemandVideos(category.id))

  const videoItemsToRender =
    (onDemandVideos && (
      <Tabs
        sx={(theme) => {
          return {
            ...styles(theme).iconSize,
            ...styles(theme).iconPadding,
            ...styles(theme).showWhenDisabled,
            '& .MuiTabs-indicator': {
              backgroundColor: '#ff00ff', // custom pink color
            },
          }
        }}
        value={0}
        textColor="primary"
        variant="scrollable"
        scrollButtons
        slotProps={{
          indicator: {
            style: { display: 'none' }, // or use sx: { display: 'none' }
          },
        }}
      >
        {onDemandVideos.map((x) => {
          const isThisTheActiveVideo = activeVideo && activeVideo.id === x.id ? true : false
          return <ItemVideo1 video={x} key={x.id} isThisTheActiveVideo={isThisTheActiveVideo} />
        })}
      </Tabs>
    )) ||
    (fetchLoading && <Spinner />)
  return (
    <>
      <CategoryHeader title={category.name} />
      {videoItemsToRender}
    </>
  )
}

const CategorySectionLatest = ({ category, activeVideo }) => {
  //const classes = useStyles({})()
  const fetchLoading = useAppSelector(homeSelectors.selectFetchVideosLoading(category.id))
  const onDemandVideos: Array<VideoObject> = useAppSelector(homeSelectors.selectOnDemandVideos(category.id))

  const videoItemsToRender =
    (onDemandVideos &&
      onDemandVideos.map((x) => {
        const isThisTheActiveVideo = activeVideo && activeVideo.id === x.id ? true : false
        return <ItemVideo2 video={x} key={x.id} isThisTheActiveVideo={isThisTheActiveVideo} />
      })) ||
    (fetchLoading && <Spinner />)

  return (
    <>
      <CategoryHeader title={category.name} />
      <Tabs
        sx={(theme) => ({
          ...styles(theme).iconSize,
          height: '1050px',
          '& .Mui-disabled': {
            opacity: 0,
            height: 0,
          },
        })}
        value={0}
        textColor="primary"
        variant="scrollable"
        orientation="vertical"
        scrollButtons="auto"
        slotProps={{
          indicator: {
            style: { display: 'none' }, // or use sx: { display: 'none' }
          },
        }}
      >
        {videoItemsToRender}
      </Tabs>
    </>
  )
}

const CategoryHeader = ({ title }) => {
  return (
    <>
      <div style={{ paddingBottom: '6px', textAlign: 'left', marginTop: '20px' }}>
        <Box
          component="span"
          sx={(theme) => {
            return styles(theme).category
          }}
          style={{ padding: '8px', boxSizing: 'border-box' }}
        >
          {title}
        </Box>
      </div>
      <Box
        component="div"
        sx={(theme) => {
          return styles(theme).category
        }}
        style={{ width: '100%', height: '2px', marginBottom: '8px' }}
      ></Box>
    </>
  )
}

export default OnDemandVideoList
